import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar } from "react-icons/fa";
import { IoCalendarOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { TostMessageContext } from "../context/TostMessage";
import { MenuContext } from "../context/MenuContext";
import FullCalendar from "@fullcalendar/react";
import _default from "@fullcalendar/daygrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { PiBuildingApartment } from "react-icons/pi";
import { TbBrandBooking } from "react-icons/tb";
import { BlockDatesModal } from "../components/block_dates_modal";


function getMonthNameFromDate(dateString) {
	const [day, month, year] = dateString.split("-");
	const dateObject = new Date(`${year}-${month}-${day}`);
	const monthName = new Intl.DateTimeFormat("en-US", { month: "long" }).format(dateObject);
	return monthName;
}
function formatDate(dateString) {
	const options = { year: 'numeric', month: 'long', day: 'numeric' };
	const date = new Date(dateString);
	return new Intl.DateTimeFormat('en-US', options).formatToParts(date);
}
function generateMonthObjects() {
	const currentYear = new Date().getFullYear();
	const monthObjects = [];

	for (let month = 0; month < 12; month++) {
		const monthIndex = month + 1;
		const monthString = monthIndex < 10 ? `0${monthIndex}` : `${monthIndex}`;

		const dateString = `01-${monthString}-${currentYear}`;

		const monthObject = {
			label: new Intl.DateTimeFormat("en-US", { month: "long" }).format(new Date(`${currentYear}-${monthString}-01`)),
			value: dateString,
		};

		monthObjects.push(monthObject);
	}

	return monthObjects;
}
function getCurrentMonthDate() {
	const currentDate = new Date();

	const day = currentDate.getDate();
	const month = currentDate.getMonth() + 1;
	const year = currentDate.getFullYear();

	const dayString = day < 10 ? `0${day}` : `${day}`;
	const monthString = month < 10 ? `0${month}` : `${month}`;

	return `${dayString}-${monthString}-${year}`;
}

export default function Home() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [pageLoading, setPageLoading] = useState(false);
    const { setTostMessage } = useContext(TostMessageContext);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
	  const [currentPage, setCurrentPage] = useState(1);
    const [selectedMonth, setSelectedMonth] = useState(getCurrentMonthDate());
    const [OfficeSchedules, setOfficeSchedules] = useState(null);
	  const [itemsPerPage] = useState(5);
    const [monthObject, setMonthObject] = useState(null);
    const [bookingDetails, setBookingDetails] = useState(null);
    const [fetchinBookingDetails, setFetchinBookingDetails] = useState(false)
    const [businessStats, setBusinessStats] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [pageData, setPageData] = useState({});
    const [currentCalendarView, setCurrentCalendarView] = useState({});

    useEffect(() => {
      // getData();
    }, [])

    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = OfficeSchedules?.slice(indexOfFirstItem, indexOfLastItem);
    
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(OfficeSchedules?.length / itemsPerPage); i++) {
      pageNumbers.push(i);
    }
    useEffect(() => {
      setMonthObject(generateMonthObjects());
      getStats();
    }, []);

    useEffect(() => {
      (async () => {
        // getData();
      })();
    }, [selectedMonth]);

    async function getStats() {
      setPageLoading(true)
      const formData = new FormData();
      try {
          const response = await axios.post(base_url + '/home.php', formData, {
              headers: {
                  "Content-Type": "multipart/form-data",
                  token: cookies?.userProfile?.session,
                  accountid: cookies?.userProfile?.main_id,
              },
          });
          setPageLoading(false)
          setBusinessStats({...response.data.data});
      } catch (error) {
          setPageLoading(false)
          setTostMessage({
            messageType: 'error',
            message: 'Network Error'
          })
      }
    }

    async function getData(start_date, end_date) {
        const formData = new FormData();
        formData.append('month_of_attendance', selectedMonth)
        formData.append('start_date', start_date)
        formData.append('end_date', end_date)

        try {
            const response = await axios.post(base_url + '/calendar.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            setOfficeSchedules([...response.data.data]);
            setPageData({...pageData, apartments: response.data.apartments });
        } catch (error) {

        }
    }

  function handleDatesSet(dateInfo) {
		// Load or update events based on dateInfo.start and dateInfo.end
		// This is where you fetch data for the new month displayed
    getData(dateInfo.startStr, dateInfo.endStr)
    setCurrentCalendarView({ startStr: dateInfo.startStr, endStr: dateInfo.endStr });
	}

  function handleSelect(info) {
    console.log(info)
    setShowModal(true);
    setPageData({...pageData, startDate: info.startStr, endDate: info.endStr});
  }

  async function clickedEvent(e) {
      e.jsEvent.preventDefault();
      if (e.event.extendedProps.type == "booked") {
        setBookingDetails(null)
        setFetchinBookingDetails(true)
        const formData = new FormData();
        formData.append('rrr', e.event.url)
        try {
            const response = await axios.post(base_url + '/get-booking-details.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            setFetchinBookingDetails(false)
            if (response.data.status) {
                setBookingDetails({...response.data.data});
            } else {
              setTostMessage({
                messageType: 'warning',
                message: 'Unable to load booking details'
              })
            }
        } catch (error) {
          setFetchinBookingDetails(false)
        }
      } else {
        if (window.confirm(`Are you sure you want to re-open these dates for ${e.event.extendedProps.aparment_name}`)) {
          setPageLoading(true)
          const formData = new FormData();
          formData.append('blocking_id', e.event.url)
          try {
              const response = await axios.post(base_url + '/remove_blocked_dates.php', formData, {
                  headers: {
                      "Content-Type": "multipart/form-data",
                      token: cookies?.userProfile?.session,
                      accountid: cookies?.userProfile?.main_id,
                  },
              });
              setPageLoading(false)
              if (response.data.status) {
                setTostMessage({
                  messageType: 'success',
                  message: response.data.message
                })
                getData(currentCalendarView?.startStr, currentCalendarView?.endStr);
              } else {
                setTostMessage({
                  messageType: 'warning',
                  message: response.data.message
                })
              }
          } catch (error) {
            setPageLoading(false)
            setTostMessage({
              messageType: 'error',
              message: 'Network error'
            })
          }
        }
      }
  }

  useEffect(() => {
    console.log(bookingDetails)
  }, [bookingDetails])

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {showModal &&
      <BlockDatesModal 
          setShowModal={setShowModal}
          getData={getData}
          pageData={pageData}
          startStr={currentCalendarView?.startStr}
          endStr={currentCalendarView?.endStr}
      />
      }
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
          <div className="h-full py-6 px-10 flex flex-col justify-start">
            {/* <h2 className="text-xl md:text-2xl text-black font-bold">{'Dashboard'}</h2> */}
            <div className="animate-fadeIn mt-0 w-full bg-white rounded-3xl border p-6 shadow-sm grid grid-cols-2 md:grid-cols-4">
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <PiBuildingApartment className="w-5 h-5" />
                    Branches
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl md:text-5xl">{businessStats?.branches}</p>
                  </div>
                </div>
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <PiBuildingApartment className="w-5 h-5" />
                    Apartments
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl md:text-5xl">{businessStats?.branch_apartments}</p>
                  </div>
                </div>
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <TbBrandBooking className="w-5 h-5" />
                    Upcoming Bookings
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl md:text-5xl">{businessStats?.upcoming_bookings}</p>
                  </div>
                </div>
                <div className="flex-1">
                  <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                    <TbBrandBooking className="w-5 h-5" />
                    Total Bookings
                  </label>

                  <div className="relative">
                      <p className="font-bold text-3xl md:text-5xl">{businessStats?.total_bookings}</p>
                  </div>
                </div>
            </div>
            <div className="h-auto md:h-[-webkit-fill-available] flex flex-col md:flex-row justify-between w-full mt-10">
              <div className="w-full md:w-[65%] h-[-webkit-fill-available]">
	                <FullCalendar 
                  selectable={true}
                  contentHeight={'auto'} dayHeaders={true} eventClick={clickedEvent} select={handleSelect} dayMaxEvents={3} plugins={[interactionPlugin, dayGridPlugin]} initialView="dayGridMonth" selectMirror={true} events={OfficeSchedules} datesSet={handleDatesSet} />
				      </div>
              <div className="w-full flex flex-col-reverse md:flex-col md:w-[30%] h-[-webkit-fill-available]">
                <div className="flex flex-col items-center my-5">
                    <button onClick={() => !navigate(`/dashboard/book-apartment`) } className="bg-primary text-white flex flex-row items-center justify-evenly w-full h-[50px] px-5 rounded-2xl shadow-md shrink-0 text-lg font-cormorant-bold">
                        <span className="text-white font-cormorant-bold text-lg update-price">Add New Reservation</span>
                    </button>
                </div>
                <div className="sticky top-10 h-[min-content]">
                    {fetchinBookingDetails && (
                      <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
                        <p>Fetching details...</p>
                      </div>
                    )}
                    {(!fetchinBookingDetails && bookingDetails == null) && 
                    (
                      <div className="font-semibold bg-white rounded-xl shadow-md p-6 space-y-6">
                        <p>Select a booking from calendar to see details</p>
                      </div>
                    )} 
                    {(bookingDetails !== null) && (
                    <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
                      <div className="border rounded-lg p-4 text-sm">
                        <div className="flex justify-between">
                            <div>
                            <p className="text-black font-semibold">Check-in</p>
                            <p className="font-aileron-regular">{bookingDetails?.check_in}</p>
                            </div>
                            <div>
                            <p className="text-black font-semibold">Check-out</p>
                            <p className="font-aileron-regular">{bookingDetails?.check_out}</p>
                            </div>
                        </div>
                      </div>
                      <div className="flex flex-col justify-start text-sm">
                        <p className="font-aileron-regular">Guest Name: {bookingDetails?.first_name}{" "}{bookingDetails?.last_name}</p>
                        <p className="font-aileron-regular">Guest Phone: {bookingDetails?.phone_number}</p>
                        <p className="font-aileron-regular">Guest Email: {bookingDetails?.email}</p>
                      </div>
                      <div className="text-sm space-y-2">
                        <div className="flex justify-between">
                            <p className="font-aileron-regular">Amount Paid: {bookingDetails?.amount_paid}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="font-aileron-regular">Booking Amount: {bookingDetails?.booking_amount}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="font-aileron-regular">Refundable Deposit: {bookingDetails?.refundable_deposit}</p>
                        </div>
                        <div className="flex justify-between">
                            <p className="font-aileron-regular">Tax: {bookingDetails?.taxes}</p>
                        </div>
                        {/* <div className="flex justify-between">
                            {bookingDetails?.free_cancellation == "YES" && <p className="font-aileron-regular">Free Cancellation: {bookingDetails?.free_cancellation} - {bookingDetails?.currency} {bookingDetails?.free_cancellation_amount}</p>}
                            {bookingDetails?.free_cancellation == "NO" && <p className="font-aileron-regular">Free Cancellation: {bookingDetails?.free_cancellation}</p>}
                        </div> */}
                        <div className="flex flex-col justify-start addon_list">
                            <p className="text-black font-aileron-regular">Apartments Booked</p>
                            <ul>
                            {bookingDetails?.apartments_booked?.map((service, index) => {
                                return (
                                  <li><div className="flex flex-col">
                                    <p key={index} className="font-aileron-regular font-semibold mt-1">{index+1}. {service.apt_name} - {service.apt_cat}</p>
                                    <p key={index} className="font-aileron-regular mt-1">Plan: {service.apt_plan}</p>
                                  </div></li>
                                )
                            })}
                            </ul>
                        </div>
                        <div className="flex flex-col justify-start addon_list">
                            <p className="text-black font-semibold">Add-ons</p>
                            {bookingDetails?.booking_addons?.map((service, index) => {
                                return (
                                    <p key={index} className="font-aileron-regular mt-1">{service.service_name}</p>
                                )
                            })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
        </div>
    </div>
  );
}
